import { render, staticRenderFns } from "./perdidaRecompensa.vue?vue&type=template&id=c82d802e&scoped=true"
import script from "./perdidaRecompensa.vue?vue&type=script&lang=js"
export * from "./perdidaRecompensa.vue?vue&type=script&lang=js"
import style0 from "./perdidaRecompensa.vue?vue&type=style&index=0&id=c82d802e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82d802e",
  null
  
)

export default component.exports